module.exports = __webpack_public_path__ + "static/media/icomoon.073af758.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/icomoon.woff?v1g914
// module id = 248
// module chunks = 0